import { useNavigate } from 'react-router';
import { t } from 'i18next';
import { Button, Text } from '@datanomik/core-ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div
      data-modern
      className="flex min-h-[60vh] flex-col items-center justify-center gap-6 p-10 font-sans"
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <Text as="p" className="text-6xl font-semibold tracking-tight text-primary">404</Text>
        <Text variant="body" tone="muted">{t('Page not found')}</Text>
      </div>

      <Button variant="outline" onClick={() => navigate('/')}>
        {t('Back to home page')}
      </Button>
    </div>
  );
}
